<template>
  <MobilePopup
    class="scholar-page-mobile"
    :popupVisible="popupVisible"
    :src="src"
    :background="background"
    @monitorEvent="monitorEvent"
    @closePopup="closePopup">
  </MobilePopup>
</template>
<script>
import { getQrcodeMobile } from '@/api/index'
import MobilePopup from '@/components/MobilePopup'
import background from '@/assets/open_dialog_mobile.png'
export default {
  props: {
    popupVisible: Boolean
  },
  data () {
    return {
      src: null,
      background: background
    }
  },
  created () {
    // 微信扫码登录
    getQrcodeMobile()
      .then((data) => {
        this.src = data.data.qrcode_img_url
      })
      .catch((err) => console.log(err))
  },
  methods: {
    monitorEvent () {

    },
    closePopup () {
      this.$emit('closePopup')
    }
  },
  components: {
    MobilePopup
  }
}
</script>
<style lang="scss">
.scholar-page-mobile {
  .qrcode {
    position: absolute;
    width: 150px;
    height: 150px;
    top: 37%;
    left: 50%;
    transform: translate(-50%,-50%);
    border: 1px solid #e6e6e6;
    padding: 0;
  }
  &.popup {
    background: none;
  }
  .icon--close {
    right: 4%;
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MobileLoginDialog/index.vue